type MarginStyle = string | number;

export const mr = (margin: MarginStyle): React.CSSProperties => ({
  marginRight: margin,
});

export const ml = (margin: MarginStyle): React.CSSProperties => ({
  marginLeft: margin,
});

export const mt = (margin: MarginStyle): React.CSSProperties => ({
  marginTop: margin,
});

export const mb = (margin: MarginStyle): React.CSSProperties => ({
  marginBottom: margin,
});

export const margin = (margin: MarginStyle): React.CSSProperties => ({ margin });
